const formatter = Intl.NumberFormat('en-US');

export default function formatNumber(num: number, suffix?: string) {
  const formatted = formatter.format(num);
  if (suffix) {
    return `${formatted} ${suffix}`;
  }
  return formatted;
}
